import get from 'lodash-es/get';
import { Division } from '@reg/shared/model/division.model';
import { Wrestler } from '@reg/shared/model/wrestler.model';
import { Order } from '@reg/shared/model/order.model';
import { JsonApiModel } from './json-api.model';

/**
 * Model to hold configured additional information to be collected during registration
 */
export class AdditionalInfo extends JsonApiModel {
    public name: string = null;
    public sequence: number = null;
    public entityName: string = null;
    public isRequired: boolean = false;
    public isEnabled: boolean = true;
    public divisions: Division[] = [];
    public eventId: string = null;

    public getCollectionLevelName(entityName?: string): string {
        entityName = entityName || this.entityName;

        if (entityName === Order.ENTITY_NAME) {
            return 'Per Order';
        } if (entityName === Wrestler.ENTITY_NAME) {
            return 'Per Athlete';
        }

        return null;
    }

    public clone(): AdditionalInfo {
        const clone: AdditionalInfo = new AdditionalInfo(this.id);
        clone.name = this.name;
        clone.sequence = this.sequence;
        clone.entityName = this.entityName;
        clone.isRequired = this.isRequired;
        clone.isEnabled = this.isEnabled;
        clone.eventId = this.eventId;
        clone.divisions = this.divisions && this.divisions.map((d: Division) => d.clone());

        return clone;
    }

    public requireDivisions(): boolean {
        return this.entityName === Wrestler.ENTITY_NAME;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {
            data: {
                id: this.id,
                type: 'additionalInfo',
                attributes: {
                    name: this.name,
                    sequence: this.sequence && parseInt(this.sequence.toString(), null),
                    entityName: this.entityName,
                    isRequired: this.isRequired,
                    isEnabled: this.isEnabled,
                },
            },
        };

        if (this.divisions !== null) {
            json.data.relationships = {
                divisions: {
                    data: this.divisions.map((d: Division) => ({ type: 'division', id: d.id })),
                },
            };
        }

        return JSON.stringify(json);
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: any, included: any[]): AdditionalInfo {
        const data: any = json.data || json;
        const attrs: any = data.attributes || {};

        this.id = data.id;
        this.name = attrs.name;
        this.entityName = attrs.entityName;
        this.sequence = attrs.sequence;
        this.isRequired = attrs.isRequired;
        this.isEnabled = attrs.isEnabled;
        this.eventId = attrs.eventId;

        const divisionList: any[] = get(data, 'relationships.divisions.data') || [];
        divisionList.forEach((x: any) => {
            this.divisions = this.divisions || [];
            const item: any = included.find((i: any) => i.id === x.id);

            if (item) {
                this.divisions.push((new Division()).deserialize(item, included));
            }
        });

        return this;
    }
}
